(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tag-filter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const copyText = async (value) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return;
      }

      const textArea = document.createElement('textarea');
      textArea.value = value;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      textArea.remove();
    };

    const initializeTagHelpers = (root = document) => {
      root.querySelectorAll('[data-collection-tag-helper]:not([data-initialized])').forEach((helper) => {
        helper.dataset.initialized = 'true';

        const search = helper.querySelector('[data-collection-tag-search]');
        const list = helper.querySelector('[data-collection-tag-list]');
        const empty = helper.querySelector('[data-collection-tag-empty]');
        const status = helper.querySelector('[data-collection-tag-status]');
        let tags = [];

        try {
          tags = JSON.parse(helper.dataset.tags || '[]');
        } catch (error) {
          empty.textContent = 'Collection tags could not be loaded.';
          empty.hidden = false;
          return;
        }

        const renderTags = () => {
          const query = search.value.trim().toLocaleLowerCase();
          const matches = tags.filter((tag) => tag.toLocaleLowerCase().includes(query));
          const fragment = document.createDocumentFragment();

          matches.forEach((tag) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'collection-tag-filter__editor-tag';
            button.dataset.collectionTag = tag;
            button.textContent = tag;
            fragment.appendChild(button);
          });

          list.replaceChildren(fragment);
          empty.hidden = matches.length > 0;
          status.textContent = '';
        };

        search.addEventListener('input', renderTags);
        list.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-collection-tag]');

          if (!button) return;

          try {
            await copyText(button.dataset.collectionTag);
            status.textContent = `Copied “${button.dataset.collectionTag}”.`;
          } catch (error) {
            status.textContent = 'Copy failed. Select the tag text and copy it manually.';
          }
        });

        renderTags();
      });
    };

    initializeTagHelpers();
    document.addEventListener('shopify:section:load', (event) => initializeTagHelpers(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-restock"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-items"] && !Shopify.designMode) return;
  try {
    
  class RelatedProductsCarousel {
    constructor(container) {
      this.container = container;
      this.carousel = container.querySelector('[data-carousel="carousel"]');
      if (!this.carousel) return;

      this.prevBtn = container.querySelector('.carousel-nav--prev');
      this.nextBtn = container.querySelector('.carousel-nav--next');
      this.updateButtons = this.updateButtons.bind(this);

      this.prevBtn?.addEventListener('click', () => this.scroll('prev'));
      this.nextBtn?.addEventListener('click', () => this.scroll('next'));
      this.carousel.addEventListener('scroll', this.updateButtons, { passive: true });

      this.resizeObserver = new ResizeObserver(this.updateButtons);
      this.resizeObserver.observe(this.carousel);
      this.updateButtons();
    }

    scroll(direction) {
      const scrollAmount = this.carousel.offsetWidth;
      const scrollLeft = direction === 'prev' ? -scrollAmount : scrollAmount;
      this.carousel.scrollBy({ left: scrollLeft, behavior: 'smooth' });
    }

    updateButtons() {
      const atStart = this.carousel.scrollLeft <= 1;
      const atEnd =
        this.carousel.scrollLeft + this.carousel.clientWidth >=
        this.carousel.scrollWidth - 1;

      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;
    }
  }

  const initializeRelatedProductCarousels = (root = document) => {
    root.querySelectorAll('.related-items .resource-list-wrapper--carousel').forEach((wrapper) => {
      if (wrapper.dataset.carouselInitialized === 'true') return;

      wrapper.dataset.carouselInitialized = 'true';
      new RelatedProductsCarousel(wrapper);
    });
  };

  initializeRelatedProductCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    initializeRelatedProductCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
